// extracted by mini-css-extract-plugin
export default {"control__buttons-box":"a_bm","control__button-datatable":"a_bo"};